import {RootState} from "../../../app/store";

export const selectLocation = (state: RootState) => state.control.location

export const selectSubLocation = (state: RootState) => state.control.subLocation